import LocalizedStrings from 'react-native-localization';
import shared from '../strings/shared';

export default new LocalizedStrings({
  en: {
    list_section_disable_button: shared('Disable', 'en'),
  },
});
